/*
 * @Description:
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-03-03 09:35:44
 * @LastEditors: zhangle
 * @LastEditTime: 2024-01-30 17:29:51
 */
import axios from 'axios';
import Vue from 'vue';
import { gotoLogin } from '@/common/copyright/utils'

// 取消正在进行中的请求
let cancel = {}

function generateCancelFun(config) {
    let method = config.method
    let url = config.url.split('?')[0]
    return method + '+' + url
}
/**
 * 自定义Axios实例
 */

const AJAX = axios.create({
    baseURL: '/',
    timeout: 86400000,
    maxRedirects: 0,// 设置 maxRedirects 为 0 来禁止自动重定向
    // timeout: 1,
    // withCredentials: env.credential
});
// 添加请求拦截器
AJAX.interceptors.request.use(function (config) {
    config.cancelToken = new axios.CancelToken(function(c) {
        // config.headers['Authorization'] = 'Bearer 7400fe5688064a40a88243460d226777'
        let key = generateCancelFun(config)
        if (config.headers.allowCance) {
            cancel[key] = c;
        }
    }); 
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

export const ExcludeRequest400 = [] // 排除的请求
export const ExcludeRequest401 = ['drama/api/me?hidden=true'] // 排除的请求

// 添加响应拦截器
AJAX.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    if (response.data.code !== 200) {
        if (response.config && response.config.headers && response.config.headers.customCode === 'system') {
            Vue.prototype.$TsaToastV2.show({
                type: 'error',
                message: response.data.message || '服务异常，请稍后再试！'
            })
        }
    }
    return response.data;
}, function (error) {
    console.log(error)
    // 对响应错误做点什么，比如400、401、402等等
    if (error && error.response) {
        // console.log('我是请求的中的')
        let { status, data, config } = error.response
        let message = data.message || '服务异常，请稍后再试！'
        switch (status) {
            case 400:
                if (config.headers.network400 !== 'custom400') {
                    Vue.prototype.$TsaToastV2.show({
                        type: 'warn',
                        message
                    })
                }
                break
            case 401:
                if (ExcludeRequest401.indexOf(config.url) == -1) {
                    gotoLogin()
                }
                // if (config.headers.network401 !== 'custom401') {
                //     gotoLogin()
                // }
                break
            case 403:
                console.log(config.headers)
                if (config.headers.network403 !== 'custom403') {
                    Vue.prototype.$TsaToastV2.show({
                        message,
                        type: 'error'
                    })
                }
                break
            default:
                if (config.headers.networkError !== 'customError') {
                    Vue.prototype.$TsaToastV2.show({
                        type: 'error',
                        message
                    })
                }

        }
    } else {
        if (error.message.indexOf('timeout') > -1) {
            Vue.prototype.$TsaToastV2.show({
                type: 'error',
                message: '网络超时，请稍后再试'
            })
        }
    }
    return Promise.reject(error.response);
});
export const clearHttp = (key) => {
    if (cancel[key]) {
        cancel[key] && cancel[key]('Operation canceled by the user');
        cancel[key] = undefined
    }
}
// 定义对外Get、Post、File请求
export default {
    blob(url) {
        return AJAX.get(url, {
            responseType: "blob",
        })
    },
    get(url, params = {}, headers = {}) {
        return AJAX.get(url, {
            params,
            headers
        })
    },
    post(url, param = null, headers = {}) {
        return AJAX.post(url, param, {
            headers,
        })
    },
    put(url, param = null, headers = {}) {
        return AJAX.put(url, param, {
            headers,
        })
    },
    file(url, param = null, headers = {}) {
        return AJAX.post(url, param, {
            headers: Object.assign({
                'Content-Type': 'multipart/form-data'
            }, headers)
        })
    },
    delete(url, data = null, headers = {}) {
        return AJAX.delete(url, {
            data: JSON.stringify(data),
            headers: Object.assign({
                'Content-Type': 'application/json'
            }, headers)
        })
    },
}
